class AdpPinIconController {
  constructor() {
    this.name = 'adpPinIcon';
  }
}

export default AdpPinIconController;



// WEBPACK FOOTER //
// ./src/app/components/adpPinIcon/adpPinIcon.controller.js